export const formatPaymentStatusLabel = (status) => {
  switch (status) {
    case 'paid':
      return 'Paid';
    case 'instapay_pending':
      return 'Awaiting Instapay verification';
    case 'failed':
      return 'Failed';
    case 'pending':
      return 'Pending';
    default:
      return status ? String(status).replace(/_/g, ' ') : '—';
  }
};

export const getOrderTotals = (order) => {
  const itemsSubtotal = Number(order?.items_subtotal_egp ?? order?.total_amount ?? 0);
  const fees = order?.fees_amount_egp != null ? Number(order.fees_amount_egp) : null;
  const orderTotal = Number(order?.order_total_egp ?? (fees != null ? itemsSubtotal + fees : itemsSubtotal));
  return { itemsSubtotal, fees, orderTotal };
};
